import React, {Suspense} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import FormRow from "../form/FormRow";
import FormField from "../form/FormField";

const SurveyItem = (props) => {

  let {
    surveyItem = {},
    value,
    inputValue = {},
    errorId,
    invalid,
    readOnly,
    updateFieldValue,
  } = props;

  let {
    plainId,
    title,
    type,
    answerRequired,
    answers = [],
    otherAnswerAdd,
    otherAnswerDisplayType,
    otherAnswer,
  } = surveyItem;

  let controlType = 'input';
  if (type === 'MULTI_SELECT') {
    controlType = 'checkbox';
  } else  if (type === 'SINGLE_SELECT') {
    controlType = 'radio';
  }

  let constraint;
  let options = answers.map(answer => {
    return [answer.plainId, answer.title];
  });

  if (otherAnswerAdd === 'ADD' && otherAnswerDisplayType==='DISPLAY_COMMENT' && otherAnswer) {
    options.push({
      type: 'text',
      value: 'other',
      inputValue: inputValue['other'],
      placeholder: otherAnswer.title,
    })
  }

  const _updateFieldValue = (fieldName, value, inputValue) => {
    if (updateFieldValue) {
      updateFieldValue(fieldName, value, inputValue);
    }
  };

  const onBlur = (fieldName, value, inputValue) => {
    _updateFieldValue(fieldName, value, inputValue);
  };

  const onChange = (fieldName, value, inputValue) => {
    _updateFieldValue(fieldName, value, inputValue);
  };

  return (
    <FormRow key={plainId} rowNameId={title} required={answerRequired}>
      <FormField
        fieldName={`field_${plainId}`}
        controlType={controlType}
        constraint={constraint}
        options={options}
        readOnly={readOnly}
        errorId={errorId}
        errorIdValues={{
          field: title,
        }}
        invalid={invalid}
        value={value}
        onBlur={onBlur}
        onChange={onChange}  />
    </FormRow>
  )


};

SurveyItem.fragment = {
  surveyItem: gql`
      fragment SurveyItem_surveyItem on SurveyItem
      {
          id
          plainId
          title
          description
          displayOrder
          type
          answerRequired
          answers {
              id
              plainId
              displayOrder
              type
              dataType
              title
          }
          otherAnswerAdd
          otherAnswerDisplayType
          otherAnswer {
              id
              plainId
              type
              dataType
              title
          }
      }
  `
}

SurveyItem.defaultProps = {
  value: '',
  inputValue: '',
  errorId: undefined,
  invalid: false,
};

SurveyItem.propTypes = {
  updateFieldValue: PropTypes.func,
};

export default SurveyItem;
